// src/components/MenuStorageBar/index.tsx (Novo componente para o menu)

import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { formatStorageValueFromMB } from "../../shared/storageUtils";
import { useStorage } from "../../contexts/storage";

const MenuStorageBar: React.FC = () => {
    const { storage, progress, isStorageFull, loading, error } = useStorage();

    if (loading) {
        return <div className="text-center p-3">Carregando...</div>;
    }
    if (error) {
        return <div className="text-danger p-3">{error}</div>;
    }
    if (!storage || !progress) {
        return null;
    }

    const barColor = isStorageFull ? "#DB4437" : "#4285F4";
    
    return (
        <div 
            className="storage-menu-container px-3 card m-0" 
            style={{ 
                borderTop: isStorageFull ? `2px solid ${barColor}` : 'none',
                paddingTop: '1rem',
                paddingBottom: '1rem',
                backgroundColor: `${progress.percentage >= progress.percentageLimit ? "pink" : ""}`
            }}
        >
            <div className="d-flex align-items-center mb-2">
                <FontAwesomeIcon 
                    icon={faExclamationCircle} 
                    size="xs" 
                    className="me-3 mx-1" 
                    style={{ color: barColor }} 
                />
                <div>
                    <h6 className="mb-0" style={{ fontSize: '0.9rem' }}>
                        {isStorageFull && `Você já consumiu ${progress.percentage}%`}
                    </h6>
                </div>
            </div>

            <div className="w-100">
                <div 
                    className="storage-progress-bar-container" 
                    style={{ 
                        height: '4px', 
                        backgroundColor: '#eee', 
                        borderRadius: '2px', 
                        overflow: 'hidden' 
                    }}
                >
                    <div 
                        className="storage-progress-bar" 
                        style={{ 
                            width: `${progress.percentage}%`, 
                            height: '100%', 
                            backgroundColor: barColor 
                        }}
                    />
                </div>
                <small className="text-muted mt-2 d-block">
                    {formatStorageValueFromMB(storage.tamanhoArmazenadoEmMB)} de {formatStorageValueFromMB(storage.tamanhoArmazenamentoContratadoEmMB)}
                </small>
            </div>
        </div>
    );
}

export default MenuStorageBar;